import React from 'react';

class FieldHelpText extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  updateValue(value) {
    this.setState(
      { value },
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <div className="mb-3">
      <label htmlFor="helpText" className="form-label">Help text</label>
      <input id="helpText" name="helpText"
             type="text"
             className="form-control"
             value={this.state.value || ''}
             onChange={e => this.updateValue(e.target.value)} />
      <div className="form-text">Will appear below the field.</div>
    </div>
  }

}

export default FieldHelpText;
